import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { Subject, Subscription, EMPTY } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap } from 'rxjs/operators';

import { ActivityReportListService } from "./activity-report-list.service"
import { SnackbarService } from "../shared/services/snackbar.service";
import { SessionStorageService } from "../shared/services/session-storage.service";
import { TooltipService } from "../shared/services/tooltip.service";

import { PaginationComponent } from '../shared/components/pagination/pagination.component';

import '../../../node_modules/@mobiscroll/angular/dist/css/mobiscroll.angular.min.css';
import { MbscRangeOptions } from '../../../node_modules/@mobiscroll/angular/dist/js/mobiscroll.angular.min.js';

import { config } from "../../../config/index";
@Component({
    template: require('./activity-report-list.component.html'),
    styles: [require('./activity-report-list.component.less')],
    providers: [ActivityReportListService, SnackbarService, TooltipService],
    preserveWhitespaces: true
})
export class ActivityReportListComponent implements OnInit, OnDestroy {

    activityReportListData: any = [];
    itemsPerPage: number = 10;
    page: number = 0;
    sortParam: string;
    order: string;
    activityReportListTotalCount: number;
    startCount: number;
    endCount: number;
    searchKey: any;
    master: any;
    paginationItems: any = [];
    selectedType: any = 10;
    sortParamsConfig: any = [];
    sortParams: any = ['report_date', 'role', 'practice'];
    loading: boolean = false;

    date_from: any;
    date_to: any;
    dateError: boolean = false;
    currentYear: any = new Date().getFullYear();
    minYear: any = 1900;

    currentUserRole: any;
    isTouchDevice: boolean;
    dialogNewClasses: string;

    reqItemsPerPage: number;
    reqPageOffset: number = 0;
    searchValue: string = '';
    currentDate: any = new Date();
    filename: string;

    private _role = config.role;
    _userRoles:any = [];
    selectedRole: any;
    isFirstRoleFilter: boolean = true;

    activityReportListApiSubscription: Subscription;
    activityReportDownloadApiSubscription: Subscription;
    inputSubscription: Subscription;
    limitInputSub$: Subject<string> = new Subject<string>();

    range: any;
    rangeSettings: MbscRangeOptions = {
        buttons: ['cancel', 'clear', 'set'],
        controls: ['date'],
        dateFormat: "mm/dd/yy",
        min: new Date("01/01/" + this.minYear),
        display: 'bubble',
        focusOnClose: false,
        returnFormat: 'locale',
        theme: 'ios',
        themeVariant: 'light',
    };

    @ViewChild("datePicker", { static: false }) dateFieldRef: any;
    @ViewChild("paginationId", { static: false }) setPagination: PaginationComponent;

    constructor(
        private _activityReportListService: ActivityReportListService,
        public _mdlSnackbarService: SnackbarService,
        private _sessionStorageService: SessionStorageService,
        private _tooltipService: TooltipService
    ) {
    }

    ngOnInit() {
        for (let i = 0; i < this.sortParams.length; i++) {
            let newConfig = {
                sortDescending: true,
                firstToggle: true
            }
            this.sortParamsConfig[this.sortParams[i]] = newConfig;
        }
        this.userRoleFetch();
        this.getActivityReport(10, 0, this.searchKey);

        // add delay for setting pagination limit on typing
        this.inputSubscription = this.limitInputSub$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap(event => {
                this.setLimit(this.selectedType, event);
                return EMPTY;
            })
        ).subscribe();
    }

	/**
	 * Function called to fetch User Role
	 */
	userRoleFetch = () => {
		this._sessionStorageService.readItem(this._role).then((data: any) => {
			this.currentUserRole = data.role;
			this._userRoles = data.roles;
		});
    };

    filterChange() {
        this.loading = true;
        if (this.isFirstRoleFilter) {
            this.isFirstRoleFilter = false;
        } else {
            this.getActivityReport(this.reqItemsPerPage, this.reqPageOffset, this.searchKey);
        }
    }

    updateDateKey(value: any) {
        if (value.toString().length === 1) {
            value = "0" + value;
        }
        return value;
    }

    /**
     * Function to set values based on datepicker.
     */
    onDatePickerChange($event: any) {
        this.date_from = $event[0];
        if (this.date_from) {
            let startDate = new Date(this.date_from);
            let startDay = startDate.getDate();
            let startMon = startDate.getMonth() + 1;
            let startYear = startDate.getFullYear();
            this.date_from = this.updateDateKey(startDay) + "/" + this.updateDateKey(startMon) + "/" + startYear;
        }

        this.date_to = $event[1];
        if (this.date_to) {
            let endDate = new Date(this.date_to);
            let endDay = endDate.getDate();
            let endMon = endDate.getMonth() + 1;
            let endYear = endDate.getFullYear();
            this.date_to = this.updateDateKey(endDay) + "/" + this.updateDateKey(endMon) + "/" + endYear;
        }

        if (!this.loading) {
            this.loading = true;
            this.getActivityReport(this.reqItemsPerPage, this.reqPageOffset, this.searchKey);
        }
    }

    /**
     * Function to open Date picker.
     */
    openPicker() {
        if (document.activeElement instanceof HTMLInputElement) {
            document.activeElement.blur();
        }
        setTimeout(this.dateFieldRef.instance.show, 150);
    }

    // for sorting
    sort(param: any) {
        this.sortParam = param;
        if (this.sortParamsConfig[param].firstToggle) {
            this.sortParamsConfig[param].firstToggle = false;
        } else {
            this.sortParamsConfig[param].sortDescending = !this.sortParamsConfig[param].sortDescending;
        }
        for (let i = 0; i < this.sortParams.length; i++) {
            if (this.sortParams[i] !== param) {
                this.sortParamsConfig[this.sortParams[i]].firstToggle = true;
            }
        }
        this.sortParamsConfig[param].sortDescending ? this.order = 'des' : this.order = 'asc';
        this.getActivityReport(this.reqItemsPerPage, this.reqPageOffset, this.searchKey);
    }


    /**
    * Function to set items Per page value
    * @param  {any} limitValue
    * @param  {any} event
    */
    setLimit(limitValue: any, event: any) {
        if (limitValue !== null) {
            this.master = limitValue;
            this.setPagination.changedValue = true;
            this.setPagination.itemsPerPage = this.master;
            this.paginationItems = this.setPagination.emitterEvent();
            this.reqItemsPerPage = this.paginationItems.passedItems;
            this.reqPageOffset = this.paginationItems.reqOffset;
            this.getActivityReport(this.reqItemsPerPage, this.reqPageOffset, this.searchKey);
        }
    }

    /**
     * Function to set maximum items to be displayed in a page
     * @param  {any} selectedPageNumber
     */
    maxItemsPerPage(selectedPageNumber: any) {
        if (selectedPageNumber < this.activityReportListTotalCount) {
            this.selectedType = selectedPageNumber + 1;
            this.setLimit(this.selectedType, event)
        }
    }

    /**
     * Function to capture event emitted from pagination component
     * @param  {any} event
     */
    paginationComponentEvent(event: any) {
        if (event.isClicked) {
            this.getActivityReport(event.itemsPerPage, event.offset, this.searchKey);
        }
        this.reqItemsPerPage = event.itemsPerPage;
        this.reqPageOffset = event.offset;
    }

    /**
     * Function to set minimum no of items to be displayed in apage
     * @param  {any} selectedPageNumber
     */
    minItemsPerPage(selectedPageNumber: any) {
        if (selectedPageNumber > 1) {
            this.selectedType = selectedPageNumber - 1;
            this.setLimit(this.selectedType, event)
        }
    }

    /**
     * Function to search for Practice Name.
     */
    search() {
        this.page = 0;
        this.getActivityReport(this.reqItemsPerPage, this.reqPageOffset, this.searchKey);
    }

    getActivityReport(pageItems: any, offset: any, searchKey: any) {
        let filter = {
            date_to: '',
            date_from: '',
            role: this.selectedRole
        };

        if (this.date_to && this.date_from) {
            const newFromdate = this.date_from.split("/").reverse().join("-");
            const newTodate = this.date_to.split("/").reverse().join("-");
            filter['date_from'] = newFromdate;
            filter['date_to'] = newTodate;
        }

        this.loading = true;
        this.activityReportListApiSubscription?.unsubscribe();
        this.activityReportListApiSubscription = this._activityReportListService.activityReportList(filter, pageItems, offset, this.sortParam, this.order, searchKey)
            .subscribe((res: any) => this.getActivityReportSuccessHandler(res),
            error => {
                this.loading = false;
                this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
            });
    }

    getActivityReportSuccessHandler = (response: any) => {
        if (!response.data) {
            this.activityReportListData = [];
        } else {
            this.activityReportListData = response.data;
        }

        this.activityReportListTotalCount = response.count;
        this.loading = false;
        if (this.reqPageOffset >= 0) {
            if (this.activityReportListData.length !== 0) {
                this.startCount = this.reqPageOffset + 1;
                this.endCount = this.startCount + this.activityReportListData.length - 1;
            } else {
                this.startCount = 0;
                this.endCount = 0;
            }
        }
        return;
    }

    downloadReport(id: number, fileName: string) {
        this.loading = true;
        this.filename = fileName;

        this.activityReportDownloadApiSubscription?.unsubscribe();
        this.activityReportDownloadApiSubscription = this._activityReportListService.activityReportDownload(id).subscribe((res: any) => this.getActivityDownloadSuccessHandler(res),
            error => {
                this.loading = false;
                this._mdlSnackbarService.showSnackbar(error.message, 'error');
            });
    }

    getActivityDownloadSuccessHandler = (response: any) => {
        this.loading = false;
        if (typeof window.navigator.msSaveBlob === 'function') {
            window.navigator.msSaveBlob(response, this.filename);
        } else {
            var blob = response;
            var link = document.createElement('a');
            var binaryData: any = [];
            binaryData.push(blob);
            link.href = window.URL.createObjectURL(new Blob(binaryData, { type: "application/pdf" }))
            link.download =  this.filename;
            // append the link to the document body
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        }
        this._mdlSnackbarService.showSnackbar('REPORT_DOWNLOAD_SUCCESS', 'success');
        return;
    }

    ngOnDestroy(){
        this.activityReportListApiSubscription?.unsubscribe();
        this.activityReportDownloadApiSubscription?.unsubscribe();
        this.inputSubscription?.unsubscribe();
    }
}